module.exports = __webpack_public_path__ + "static/media/4.5.a5b03ff1.png";